import { InputViewModel } from "../../../../shared/components/shared";

export class FilterItemViewModel extends InputViewModel {

  public type: string;

}